import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import Flickity from 'flickity'
import { on } from '../modules/events.js'
import GLightbox from 'glightbox'

class WorksSection extends Section {
  initState() {
    return {}
  }

  init() {
    this.slidersSetup()

    if (this.refs.tags?.length) {
      this.tags = []
      this.refs.tags.forEach((el) => {
        on(el, 'click', () => {
          if (this.tags.includes(el.dataset.tag)) {
            this.tags = this.tags.filter((tag) => tag !== el.dataset.tag)
          }
          else {
            this.tags.splice(this.tags.length, 0, el.dataset.tag)
          }
          this.filter()
        })
      })
    }
  }

  slidersSetup() {
    if (!this.refs.sliders?.length) {
      return
    }

    this.refs.sliders.forEach((el, i) => {
      const slider = new Flickity(
        el,
        {
          contain: true,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          cellAlign: 'left',
          autoPlay: 5000 + i * 750,
        }
      )

      const indexes = Array.from(el.parentNode.querySelectorAll('.works-item-indexes span'))
      const pictures = Array.from(el.querySelectorAll('picture'))

      // load images and resize
      pictures.forEach((el) => {
        const imgEl = el.querySelector('img')
        if (!imgEl.naturalWidth) {
          on(imgEl, 'load', () => {
            setTimeout(() => slider.resize(), 100)
          })
        }
      })

      indexes.forEach((el, i) => {
        on(el, 'click', () => slider.select(i))
      })

      pictures.forEach((el, i) => {
        let timeStart = null
        on(el, 'pointerdown', () => {
          timeStart = Date.now()
        })
        on(el, 'pointerup', () => {
          const timeEnd = Date.now()
          // console.log(timeEnd - timeStart)
          if ((timeEnd - timeStart) > 70) {
            return
          }

          const gallery = GLightbox({
            elements: pictures.map((el) => ({
              type: 'image',
              href: el.dataset.src
            })),
            startAt: i
          })
          gallery.open()
        })
      })

      slider.on('change', (i) => {
        indexes.forEach((el, y) => {
          el.dataset.active = i === y ? 1 : 0
        })
      })
    })
  }

  filter() {
    this.refs.tags.forEach((el) => {
      el.dataset.active = 0
    })

    this.tags.forEach((tag) => {
      this.refs.tags.forEach((el) => {
        if (el.dataset.tag === tag) {
          el.dataset.active = 1
        }
      })
    })

    this.refs.items.forEach((el) => {
      el.dataset.active = 0
    })

    setTimeout(() => {
      this.refs.items.forEach((el) => {
        if (this.tags.length) {
          const itemTags = el.dataset.tags.split(', ')
          const activeTags = itemTags.filter((tag) => this.tags.includes(tag))
          el.dataset.active = activeTags.length ? 1 : -1
        }
        else {
          el.dataset.active = 1
        }
      })
    }, 400)
  }
}

register('works', WorksSection)
